import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from "prop-types";

const EmployeeLinkRenderer = (props) => {
  return (
    <Link to={`/organization/employees/${props.data.id}`}>{props.value}</Link>
  );
};

EmployeeLinkRenderer.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.number.isRequired
  }).isRequired,
  value: PropTypes.string.isRequired
};

export default EmployeeLinkRenderer;
